module.exports = __webpack_public_path__ + "static/media/ladditionAchats.a007b3fb.png";